import { gql } from '@apollo/client';

export default gql`
  mutation ResolveAllIssues($input: ResolveAllIssuesInput!) {
    resolveAllIssues(input: $input) {
      id
    }
  }
`;
